export class OlLegPoint {
  constructor(public lat: number,
              public lng: number,
              public name: string,
              public vehicleId: number,
              public fuelUsage: number) {
  }

  public static empty() {
    return new OlLegPoint(null, null, null, null, null);
  }

  public static fromPoint(lat: number, lng: number, name: string): OlLegPoint {
    return new OlLegPoint(lat, lng, name, null, null);
  }
}
